import {OrderResponse, OrderStatusInput} from "../data/model/ui/OrderModel";
import {editOrder, editShipping, getOrderById} from "../data/api/Customer";
import {useState} from "react";
import {ShippingFormData} from "../components/organisms/BillingEdit/BillingEdit";
import {OrderRecord} from "../components/organisms/OrdersAdmin/OrdersAdmin";

export const useOrdersHook = () => {
    const [isLoading, setIsLoading] = useState(false);

    async function updateStatus(model: OrderStatusInput) {
        setIsLoading(true);
        await editOrder(model);

        setIsLoading(false);
        return true;
    }

    async function updateShipping(model: ShippingFormData) {
        setIsLoading(true);

        await editShipping(model);

        setIsLoading(false);
        return true;
    }

    async function getOrderWithId(id: string) {
        setIsLoading(true);
        const response = await getOrderById(id);

        const {data} = response || {};

        setIsLoading(false);
        return data;
    }

    return {isLoading, updateStatus, updateShipping, getOrderWithId};
}
